/* Per-song transcription progress, stored in progress.records["song.<id>"]. */
import { getRecord, setRecord } from '../../core/store';

export interface SongState {
  /** bar index -> chord the learner wrote */
  ans: Record<number, string>;
  /** bar indexes confirmed correct */
  ok: number[];
  /** bar indexes marked wrong at the last check */
  wrong?: number[];
  checks: number;
  reveals: number;
  solved: boolean;
  /** best play-along score (percent of bars) */
  best: number;
}

export const songKey = (id: string): string => `song.${id}`;

export function loadSongState(id: string): SongState {
  const raw = getRecord<Partial<SongState>>(songKey(id));
  return {
    ans: { ...(raw?.ans || {}) },
    ok: [...(raw?.ok || [])],
    wrong: raw?.wrong ? [...raw.wrong] : undefined,
    checks: raw?.checks || 0,
    reveals: raw?.reveals || 0,
    solved: !!raw?.solved,
    best: raw?.best || 0,
  };
}

export const saveSongState = (id: string, st: SongState): void => setRecord(songKey(id), st);
export const resetSongState = (id: string): void => setRecord(songKey(id), undefined);
